import progressHandler from "../utils/progressBar";
import kindfulHandler from "../utils/kindfulHandler";

export default {
	namespace: 'project',
	beforeEnter(barba) {
		kindfulHandler(barba.next.container)
	},
	afterEnter(barba) {
		console.log('View: project')

		var vids = document.querySelectorAll("video"); vids.forEach(vid => { var playPromise = vid.play(); if (playPromise !== undefined) { playPromise.then(_ => { }).catch(error => { }); }; });

		let donationWidgetEl = barba.next.container.querySelector('.donation-widget')
		if (donationWidgetEl) {
			let bar = progressHandler(donationWidgetEl)
			let progress = donationWidgetEl.dataset.progress || 0
			bar.animate(progress)
		}

	},
	beforeLeave(barba) {

	},
	afterLeave(barba) {

	}
}
